// Copyright (c) 2025 by Audere

import { Chip, SvgIcon, SxProps, Theme, capitalize } from "@mui/material";
import { LabelingStatus, Priority } from "../features/api/labelApiSlice";
import { blue, green, orange, red } from "@mui/material/colors";
import { FlagOption } from "../features/label/labelTypes";

interface SmallChipProps {
  label?: string;
  flagData?: FlagOption;
  sx?: SxProps<Theme>;
}

const SmallChip: React.FC<SmallChipProps> = ({ label, flagData, sx }) => {
  let chipLabel = label ?? "";
  let icon = undefined;
  let additionalStyles: {
    border?: string;
    backgroundColor?: string;
    color?: string;
  } = {};

  if (flagData) {
    const optionFlagStyles = flagData.styling;
    chipLabel = flagData.name;
    icon = (
      <SvgIcon>
        <optionFlagStyles.svg fill={optionFlagStyles.iconColor} />
      </SvgIcon>
    );
    additionalStyles = {
      border: `1px solid ${optionFlagStyles.borderColor}`,
      backgroundColor: optionFlagStyles.backgroundColor,
      color: optionFlagStyles.iconColor,
    };
  }

  return (
    <Chip
      label={capitalize(chipLabel)}
      icon={icon}
      sx={{
        ...additionalStyles,
        ...sx,
      }}
      size="small"
    />
  );
};

const chipStyles = {
  fontWeight: "bold",
  padding: 1,
};

export const priorityChipStyles: Record<
  Priority,
  {
    backgroundColor: string;
    border: string;
    color: string;
    fontWeight: string;
    padding: number;
  }
> = {
  [Priority.high]: {
    backgroundColor: red[100],
    border: `1px solid ${red[800]}`,
    color: red[800],
    ...chipStyles,
  },
  [Priority.standard]: {
    backgroundColor: blue[100],
    border: `1px solid ${blue[800]}`,
    color: blue[800],
    ...chipStyles,
  },
};

export const statusChipStyles = {
  [LabelingStatus.label_in_progress]: {
    backgroundColor: orange[100],
    border: `1px solid ${orange[900]}`,
    color: orange[900],
    ...chipStyles,
  },
  [LabelingStatus.label_complete]: {
    backgroundColor: green[100],
    border: `1px solid ${green[800]}`,
    color: green[800],
    ...chipStyles,
  },
  [LabelingStatus.qc_in_progress]: {
    backgroundColor: orange[100],
    border: `1px solid ${orange[900]}`,
    color: orange[900],
    ...chipStyles,
  },
  [LabelingStatus.qc_complete]: {
    backgroundColor: green[800],
    border: `1px solid ${green[800]}`,
    color: "white",
    ...chipStyles,
  },
};

export default SmallChip;
